  //image code
$(document).ready(function(){
setTimeout(function(){
 var img = $('[data-element-id=image-swatches-1]').find('.gpo-swatch__image').eq(0).css('background-image').replace(/^url\(['"](.+)['"]\)/, '$1');
  // console.warn("-------------",img.replace('_75x',''));
  var original_img = img.replace('_75x','');
  $('.cstm_imgimg img').attr('src',original_img);
  $('.gpo-col-12').eq(3).remove();
  }, 2000);

  $('body').on('click','[data-element-id=image-swatches-1] .gpo-swatch__inner',function(){
 var img=  $(this).find('.gpo-swatch__image').css('background-image').replace(/^url\(['"](.+)['"]\)/, '$1');
    // console.warn('ddd',img);
    var original_img = img.replace('_75x','');
    $('.cstm_imgimg img').attr('src',original_img);
  });

setTimeout(function(){
 var img = $('[data-element-id=image-swatches-2]').find('.gpo-swatch__image').eq(0).css('background-image').replace(/^url\(['"](.+)['"]\)/, '$1');
  // console.warn("-------------",img.replace('_75x',''));
  var original_img = img.replace('_75x','');
  var htm= `<div class="sendcond__image"><img src="${original_img}"></div>`;
  // $('.cstm_imgsecond img').attr('src',original_img);
  $('[data-element-id=image-swatches-2]').prepend(htm);
  }, 2000);

  $('body').on('click','[data-element-id=image-swatches-2] .gpo-swatch__inner',function(){
 var img=  $(this).find('.gpo-swatch__image').css('background-image').replace(/^url\(['"](.+)['"]\)/, '$1');
    // console.warn('ddd',img);
    var original_img = img.replace('_75x','');
    var htm= `<div class="sendcond__image"><img src="${original_img}"></div>`;
    // $('.cstm_imgsecond img').attr('src',original_img);
    $('[data-element-id=image-swatches-2]').find('.sendcond__image').remove();
    $('[data-element-id=image-swatches-2]').prepend(htm);
  });
});